export default __webpack_public_path__ + "static/media/file.211512bf.svg";